<template lang='pug'>
  Contact(:title='title')
</template>

<script>
import Contact from "../components/Contact.vue";
export default {
  name: "Contact Us",
  components: {
    Contact
  },
  data: () => ({
    title: "Contact Us"
  }),
};
</script>

<style>
.v-main__wrap{
  background: #F3F3F4;
}

.v-application .blue {
  background-color: #01C8F1!important;
  border-color: #01C8F1!important;
}
</style>
